import { AppRipple } from './src/AppRipple.js';

window.customElements.define('app-ripple', AppRipple);
